import { OrderFeedbackGuestExperienceState } from './types'

// Mirrors nexus PR thanx/nexus#1977's own column defaults
// (order_feedback_call_the_store_enabled defaults to true,
// order_feedback_acknowledgment_message defaults to 'Thanks for your
// feedback.'), and both fields seed edited/persisted equally so the pane opens
// CLEAN before the initialize hook resolves the real merchant, rather than
// flashing a dirty Publish button on first paint.
export const initialOrderFeedbackGuestExperienceState: OrderFeedbackGuestExperienceState =
  {
    callTheStoreEnabled: true,
    acknowledgmentMessage: 'Thanks for your feedback.',
    persistedCallTheStoreEnabled: true,
    persistedAcknowledgmentMessage: 'Thanks for your feedback.',
    isFormSubmitting: false,
  }
